<template>
  <div class="footer">
    <div class="contactInfo mainBody">
      <div class="left">
        <img @click="toAboutUs" class="footLogo" src="@/assets/PC/footer/footerLogo.png" alt="">
        <div class="infoItem">
          <span>
            {{$t('footer.addressLabel')}}
            {{$t('footer.addressValue')}}
          </span>
        </div>
        <div class="infoItem">
          <span>
            {{$t('contactUs.zhAddress')}}
            {{$t('contactUs.address1')}}
          </span>
        </div>
        <div class="infoItem">
          <span>
            {{$t('contactUs.enAddress')}}
            {{$t('contactUs.address2')}}
          </span>
        </div>
      </div>
      <div class="QRCode">
        <img src="@/assets/PC/footer/QRCode.png" alt="">
        <span>{{$t('contactUs.watch')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footerPage',
  methods: {
    toAboutUs () {
      if (this.$route.name === 'aboutUs') {
        window.scrollTo(0, 0)
      } else {
        this.$router.push({
          name: 'aboutUs'
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  background-color: #252525;
  padding: 0.8rem 0;
  color: #fff;
}
.contactInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  >div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .left {
    width: 75%;
    .footLogo {
      width: 1.6rem;
      cursor: pointer;
    }
    .infoItem {
      display: flex;
      align-items: center;
      font-size: 0.36rem;
      text-align: left;
      img {
        width: 0.48rem;
        height: 0.48rem;
        margin-right: 0.2rem;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .QRCode {
    align-items: center;
    justify-content: flex-end;
    img {
      width: 2.4rem;
      height: 2.4rem;
      margin-bottom: 0.32rem;
    }
    span {
      color: #fff;
      font-size: 0.36rem;
    }
  }
}
</style>
